import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NgRedux, Select} from '@angular-redux3/store';
import {Observable} from 'rxjs';

import {ALogin, PlaylistRemoteAppState} from '../../store';
import {filter} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {environment} from '../../../environments/environment';
import {HelpComponent} from '../side-panel/help/help.component';

@Component({
  selector: 'mwo-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginPage implements OnInit {
  currentApplicationVersion = environment.appVersion;
  @Select(['user', 'loggedIn']) isLoggedIn$: Observable<boolean>;
  loginForm = new FormGroup({
    username: new FormControl('', [
      Validators.required,
      Validators.minLength(1)
    ]),
    password: new FormControl('', Validators.required),
    rememberMe: new FormControl(''),
  });
  public backgroundImage: string | undefined;
  private readonly imageNames: string[] = [
    'login-bg-1.webp',
    'login-bg-2.webp',
    'login-bg-3.webp',
    'login-bg-4.webp',
    'login-bg-5.webp'
  ];

  constructor(
    private router: Router,
    private ngRedux: NgRedux<PlaylistRemoteAppState>,
    public dialog: MatDialog
  ) {
  }

  ngOnInit() {
    localStorage.clear();
    this.backgroundImage = this.getRandomImagePath();
    localStorage.setItem('bgUrl', this.backgroundImage);

    if (environment.enableDesktopMode) {
      this.loginForm.get('username').setValue('desktop');
      this.loginForm.get('password').setValue('desktop');
      this.loginForm.get('rememberMe').setValue('true');
      this.onSubmit();
    }
    this.isLoggedIn$.pipe(filter(Boolean)).subscribe(() =>
      this.router.navigate(['/zones'])
    );

    this.dialog.closeAll();
  }

  onSubmit() {
    if (this.loginForm.valid) {
      const { username, password, rememberMe } = this.loginForm.controls;
      const payload = {
        email: username.value,
        password: password.value,
        rememberMe: Boolean(rememberMe.value),
      };
      this.ngRedux.dispatch(ALogin(payload));
    }
  }

  getRandomImagePath(): string {
    const randomIndex = Math.floor(Math.random() * this.imageNames.length);
    return `assets/login-bg/${this.imageNames[randomIndex]}`;
  }

  openHelpPopup() {
    this.dialog.open(HelpComponent, {
      width: '302px',
      height: '23Opx',
    });
  }
}
